<template>
  <div>
    <div class="step-hd">
      <h2>上传证件，自动识别</h2>
      <p>营业执照与法人身份证拍照上传，OCR 自动回填表单</p>
    </div>
    <div class="step-layout step-layout-2">
      <div class="col-stack">
        <div class="card">
          <div class="card-bd">
            <div class="sec-title">营业执照</div>
            <div class="sec-desc">
              上传后自动识别企业名称、信用代码、法人等信息
            </div>
            <el-form :model="form">
              <ImgUpload
                :upload-config="{
                  lebal: '企业营业执照',
                  prefix: 'businessLicense',
                  form: form,
                  suffix: 'Img'
                }"
                :required="true"
                @handleImgSuccess="businessImgSuccess"
              />
            </el-form>
          </div>
        </div>
        <div class="card">
          <div class="card-bd">
            <div class="sec-title">法人身份证</div>
            <div class="sec-desc">上传人像面与国徽面</div>
            <div class="up-mini">
              <el-form :model="form">
                <ImgUpload
                  :upload-config="{
                    lebal: '法人身份证人像面照片',
                    prefix: 'identification',
                    form: form,
                    suffix: 'Img'
                  }"
                  :required="true"
                  @handleImgSuccess="ficationImgSuccess"
                />
              </el-form>
              <el-form :model="form">
                <ImgUpload
                  :upload-config="{
                    lebal: '法人身份证国徽面照片',
                    prefix: 'identificationBack',
                    form: form,
                    suffix: 'Img'
                  }"
                  :required="true"
                  @handleImgSuccess="ficationImgBackSuccess"
                />
              </el-form>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-bd">
            <div class="sec-title" style="justify-content:space-between">
              道路运输经营许可证
              <span
                class="road-tag"
                :class="{ 'road-tag-err': roadNetworkFreight }"
                >{{
                  roadNetworkFreight
                    ? "不可用"
                    : roadRequired
                    ? "需补传"
                    : "选填"
                }}</span
              >
            </div>
            <div class="sec-desc">
              如营业执照经营范围包含「网络货运」，请补充上传本证
            </div>
            <el-form :model="form">
              <ImgUpload
                :upload-config="{
                  lebal: '道路运输经营许可证',
                  prefix: 'supplementaryMaterials1',
                  form: form,
                  suffix: 'Img'
                }"
                :required="false"
                @handleImgSuccess="roadImgSuccess"
              />
            </el-form>
            <div v-if="roadNetworkFreight" class="road-warn">
              识别到该许可证业务范围包含「网络货运」。网络货运经营者不能作为托运人入驻本平台，请更换普通道路货运经营许可证后再提交。
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-hd">
          <h3>识别信息确认</h3>
          <span v-if="ocrFilled" class="tag">OCR 已回填</span>
        </div>
        <div class="card-bd">
          <div class="g2">
            <div class="fld span2">
              <label class="fld-lbl"
                ><span class="req">*</span>企业名称<span class="ocr-tag"
                  >OCR</span
                ></label
              >
              <input
                v-model="form.companyName"
                class="fld-in"
                placeholder="自动识别"
              />
              <div class="fld-hint">须与营业执照完全一致</div>
            </div>
            <div class="fld">
              <label class="fld-lbl"
                >注册资金（万元）<span class="ocr-tag">OCR</span></label
              >
              <input
                v-model="form.registeredCapital"
                class="fld-in"
                placeholder="自动识别，可修改"
              />
            </div>
            <div class="fld">
              <label class="fld-lbl"
                >成立日期<span class="ocr-tag">OCR</span></label
              >
              <input
                v-model="form.establishDate"
                class="fld-in"
                placeholder="YYYY-MM-DD，可修改"
              />
            </div>
            <div class="fld">
              <label class="fld-lbl"
                ><span class="req">*</span>统一社会信用代码<span class="ocr-tag"
                  >OCR</span
                ></label
              >
              <input
                v-model="form.businessLicenseImgNumber"
                class="fld-in mono"
                placeholder="自动识别"
              />
            </div>
            <div class="fld">
              <label class="fld-lbl"
                ><span class="req">*</span>法定代表人<span class="ocr-tag"
                  >OCR</span
                ></label
              >
              <input
                v-model="form.legalName"
                class="fld-in"
                placeholder="自动识别"
              />
            </div>
            <div class="fld span2">
              <label class="fld-lbl"
                ><span class="req">*</span>住所<span class="ocr-tag"
                  >OCR</span
                ></label
              >
              <input
                v-model="form.address"
                class="fld-in"
                placeholder="自动识别"
              />
            </div>
            <div class="fld">
              <label class="fld-lbl"
                ><span class="req">*</span>法人身份证号<span class="ocr-tag"
                  >OCR</span
                ></label
              >
              <input
                v-model="form.identificationNumber"
                class="fld-in mono"
                placeholder="自动识别"
              />
            </div>
            <div class="fld">
              <label class="fld-lbl"
                ><span class="req">*</span>身份证有效期<span class="ocr-tag"
                  >OCR</span
                ></label
              >
              <input
                v-model="form.idCardDueDate"
                class="fld-in mono"
                placeholder="自动识别"
              />
            </div>
            <div class="fld span2">
              <label class="fld-lbl"
                ><span class="req">*</span>经营范围<span class="ocr-tag"
                  >OCR</span
                ></label
              >
              <textarea
                v-model="form.businessScope"
                class="fld-in"
                rows="2"
                placeholder="自动识别"
              ></textarea>
              <div class="fld-hint">
                包含「网络货运」的，需补充上传道路运输经营许可证
              </div>
            </div>
            <div class="fld">
              <label class="fld-lbl"
                ><span class="req">*</span>法人手机号</label
              >
              <input
                v-model="form.legalPhone"
                class="fld-in mono"
                maxlength="11"
                placeholder="法人本人常用手机号"
              />
              <div class="fld-hint">用于合同签署及重大事项核验</div>
            </div>
            <div class="fld">
              <label class="fld-lbl"
                ><span class="req">*</span>主管税务机关</label
              >
              <input
                v-model="form.myTaxOrgan"
                class="fld-in"
                placeholder="如：国家税务总局潍坊市奎文区税务局"
              />
              <div class="fld-hint">根据注册地址匹配，可修改</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="step-ft">
      <span class="note">第 1 步 / 共 3 步</span>
      <div class="step-ft-right">
        <span v-if="nextError" class="step-err">{{ nextError }}</span>
        <button type="button" class="btn btn-pri step-btn" @click="next">
          下一步 →
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ImgUpload from "@/components/ImgUpload";
import { getOcrInfo } from "@/api/shipment";
import { getInviteRoadPermitOcr } from "@/api/shipperRegisterH5";
import {
  realDay,
  validateIDNumber,
  validateIdCardDueDate
} from "@/utils/validate";

export default {
  name: "StepEnterprise",
  components: { ImgUpload },
  props: {
    value: { type: Object, required: true }
  },
  data() {
    return { nextError: "", roadNetworkFreight: false };
  },
  computed: {
    form: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    },
    ocrFilled() {
      return !!(this.form.companyName || this.form.identificationNumber);
    },
    roadRequired() {
      return String(this.form.businessScope || "").indexOf("网络货运") >= 0;
    }
  },
  watch: {
    // 删除许可证图片后复位「网络货运」拦截标志
    "form.supplementaryMaterials1Img"(val) {
      if (!val) this.roadNetworkFreight = false;
    }
  },
  methods: {
    openOcrLoading() {
      return this.$loading({
        lock: true,
        text: "图片信息提取中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.6)"
      });
    },
    // 营业执照 OCR（字段与 shipmentEdit 对齐）
    async businessImgSuccess(url) {
      const loading = this.openOcrLoading();
      try {
        const res = await getOcrInfo({
          image: url,
          ocrType: "ocrBusinessLicense"
        });
        const data = (res && res.data) || {};
        if (
          !data.companyName &&
          !data.creditNum &&
          !data.legalPerson &&
          !data.address
        ) {
          throw new Error("营业执照 OCR 未识别到有效信息，请重新上传清晰图片");
        }
        if (data.registerCapital || data.registeredCapital) {
          this.$set(
            this.form,
            "registeredCapital",
            data.registerCapital || data.registeredCapital
          );
        }
        if (data.establishDate) {
          this.$set(
            this.form,
            "establishDate",
            String(data.establishDate)
              .replace(/[年月]/g, "-")
              .replace(/日/g, "")
          );
        }
        if (data.address) {
          this.$set(this.form, "address", data.address);
        }
        if (data.creditNum && data.creditNum !== "无") {
          this.$set(this.form, "businessLicenseImgNumber", data.creditNum);
        }
        if (data.companyName && data.companyName !== "无") {
          this.$set(this.form, "companyName", data.companyName);
        }
        if (data.legalPerson && data.legalPerson !== "无") {
          this.$set(this.form, "legalName", data.legalPerson);
        }
        if (data.range) {
          this.$set(this.form, "businessScope", data.range);
        }
        this.$emit("saved");
      } catch (e) {
        this.$message.error((e && e.message) || "营业执照识别失败");
      } finally {
        loading.close();
      }
    },
    roadImgSuccess(url) {
      this.roadNetworkFreight = false;
      try {
        getInviteRoadPermitOcr({ image: url, ocrType: "ocrRoadPermitNumber" })
          .then(res => {
            const data = (res && res.data) || {};
            const text = Object.values(data).join(" ");
            if (!text.trim())
              throw new Error(
                "道路运输许可证 OCR 未识别到有效信息，请重新上传清晰图片"
              );
            this.roadNetworkFreight = text.indexOf("网络货运") >= 0;
            if (this.roadNetworkFreight) {
              this.$message.warning(
                "识别到该许可证业务范围包含「网络货运」，网络货运经营者不能作为托运人入驻本平台"
              );
            }
          })
          .catch(e => {
            this.$message.warning(
              (e && e.message) ||
                "道路运输许可证 OCR 识别失败，请重新上传清晰图片"
            );
          });
      } catch (e) {
        /* ignore */
      }
      this.$emit("saved");
    },
    // 法人身份证人像面 OCR（与 shipmentEdit 企业场景对齐）
    async ficationImgSuccess(url) {
      const loading = this.openOcrLoading();
      try {
        const res = await getOcrInfo({
          image: url,
          ocrType: "ocrIdidentityCardFront"
        });
        const data = (res && res.data) || {};
        if (!data.name && !data.identity) {
          throw new Error("身份证 OCR 未识别到有效信息，请重新上传清晰图片");
        }
        if (data.name) {
          this.$set(this.form, "legalName", data.name);
        }
        if (data.identity) {
          this.$set(this.form, "identificationNumber", data.identity);
        }
        this.$emit("legal-front-ocr");
        this.$emit("saved");
      } catch (e) {
        this.$message.error((e && e.message) || "身份证人像面识别失败");
      } finally {
        loading.close();
      }
    },
    // 法人身份证国徽面 OCR（与 shipmentEdit 对齐）
    async ficationImgBackSuccess(url) {
      const loading = this.openOcrLoading();
      try {
        const res = await getOcrInfo({
          image: url,
          ocrType: "ocrIdidentityCardFrontBack"
        });
        const data = (res && res.data) || {};
        if (!data.expiryDate) {
          throw new Error("身份证有效期 OCR 未识别到，请重新上传清晰图片");
        }
        if (data.expiryDate == "长期" || data.expiryDate == "9999-12-31") {
          this.$set(this.form, "hasDueDate", true);
          this.$set(this.form, "idCardDueDate", "9999-12-31");
        } else if (data.expiryDate) {
          const time = String(data.expiryDate).replace(/[^\d]/g, "");
          if (realDay(time)) {
            const expiryDate =
              time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
            this.$set(this.form, "idCardDueDate", expiryDate);
            this.$set(this.form, "hasDueDate", false);
          } else {
            this.$set(this.form, "idCardDueDate", data.expiryDate);
          }
        }
        this.$emit("saved");
      } catch (e) {
        this.$message.error((e && e.message) || "身份证国徽面识别失败");
      } finally {
        loading.close();
      }
    },
    next() {
      if (this.roadNetworkFreight) {
        this.nextError =
          "该道路运输经营许可证业务范围包含「网络货运」，不能作为托运人入驻本平台";
        this.$message({
          type: "warning",
          message: this.nextError,
          duration: 3000,
          offset: 60
        });
        return;
      }
      const f = this.form;
      const required = [
        ["businessLicenseImg", "请上传营业执照"],
        ["identificationImg", "请上传法人身份证人像面"],
        ["identificationBackImg", "请上传法人身份证国徽面"],
        ["companyName", "请填写企业名称"],
        ["businessLicenseImgNumber", "请填写统一社会信用代码"],
        ["legalName", "请填写法定代表人"],
        ["address", "请填写住所"],
        ["identificationNumber", "请填写法人身份证号"],
        ["idCardDueDate", "请填写身份证有效期"],
        ["businessScope", "请填写经营范围"],
        ["legalPhone", "请填写法人手机号"],
        ["myTaxOrgan", "请填写主管税务机关"]
      ];
      if (this.roadRequired) {
        required.push([
          "supplementaryMaterials1Img",
          "请上传道路运输经营许可证"
        ]);
      }
      for (const [k, msg] of required) {
        if (!f[k] || (typeof f[k] === "string" && !String(f[k]).trim())) {
          this.nextError = msg;
          this.$message({
            type: "warning",
            message: msg,
            duration: 3000,
            offset: 60
          });
          return;
        }
      }
      if (f.identificationNumber && !validateIDNumber(f.identificationNumber)) {
        this.nextError = "身份证号格式不正确，请检查后重新填写";
        this.$message.warning(this.nextError);
        return;
      }
      if (f.idCardDueDate && !validateIdCardDueDate(f.idCardDueDate)) {
        this.nextError = "身份证有效期格式不正确，请检查后重新填写";
        this.$message.warning(this.nextError);
        return;
      }
      this.nextError = "";
      this.$emit("next");
    }
  }
};
</script>

<style scoped>
.road-tag {
  font-size: 11px;
  font-weight: 600;
  color: var(--ink4);
  background: var(--line2);
  padding: 2px 8px;
  border-radius: 6px;
}
.road-tag-err {
  color: #fff;
  background: #ef4444;
}
.road-warn {
  margin-top: 10px;
  font-size: 12px;
  color: #ef4444;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 8px 12px;
  line-height: 1.6;
}
</style>
